import React from 'react';
import { Link } from 'react-router-dom';
import { Instagram, Facebook, Mail, Phone, MapPin } from 'lucide-react';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-charcoal text-white">
      <div className="container-handcraft section-spacing">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="lg:col-span-1">
            <h3 className="font-serif text-3xl mb-4">YM's Creation</h3>
            <p className="font-handwritten text-2xl text-accent mb-4">Handcrafted with Love</p>
            <p className="text-white/70 text-sm leading-relaxed">
              Creating unique, personalized handcrafted items that bring warmth and joy to your special moments.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="text-xs uppercase tracking-widest mb-6 text-white/60">Quick Links</h4>
            <ul className="space-y-3">
              <li><Link to="/shop" className="text-white/70 hover:text-white transition-colors">Shop All</Link></li>
              <li><Link to="/portfolio" className="text-white/70 hover:text-white transition-colors">Our Work</Link></li>
              <li><Link to="/about" className="text-white/70 hover:text-white transition-colors">About Us</Link></li>
              <li><Link to="/contact" className="text-white/70 hover:text-white transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* Categories */}
          <div>
            <h4 className="text-xs uppercase tracking-widest mb-6 text-white/60">Categories</h4>
            <ul className="space-y-3">
              <li><Link to="/shop/candles" className="text-white/70 hover:text-white transition-colors">Candles</Link></li>
              <li><Link to="/shop/trousseau-packing" className="text-white/70 hover:text-white transition-colors">Trousseau Packing</Link></li>
              <li><Link to="/shop/gift-bouquets" className="text-white/70 hover:text-white transition-colors">Gift Bouquets</Link></li>
              <li><Link to="/shop/portrait-paintings" className="text-white/70 hover:text-white transition-colors">Portrait Paintings</Link></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="text-xs uppercase tracking-widest mb-6 text-white/60">Get in Touch</h4>
            <ul className="space-y-4">
              <li className="flex items-center gap-3 text-white/70">
                <Mail className="w-4 h-4" />
                <span>methwani777@gmail.com</span>
              </li>
              <li className="flex items-center gap-3 text-white/70">
                <Phone className="w-4 h-4" />
                <span>+91 94081 95777</span>
              </li>
              <li className="flex items-start gap-3 text-white/70">
                <MapPin className="w-4 h-4 mt-1" />
                <span>Godhra, Gujarat, India</span>
              </li>
            </ul>
            <div className="flex gap-4 mt-6">
              <a href="https://www.instagram.com/yms_creation/" target='blank' className="w-10 h-10 rounded-full bg-white/10 flex items-center justify-center hover:bg-accent transition-colors" aria-label="Instagram">
                <Instagram className="w-4 h-4" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom */}
        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-white/50 text-sm">
            © {currentYear} YM's Creation. All rights reserved.
          </p>
          <div className="flex gap-6 text-sm text-white/50">
            <Link to="/admin" className="hover:text-white transition-colors">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
